'use client';

import { Fragment } from 'react';
import ProductListItem from '@/features/products/components/list/productListSection/productListItem';
import { ProductListRowItem } from '@/features/products/components/list/productListSection/types';
import { ListingProductCardTaxonData } from '@/features/products/components/listingProductCard/types';
import {
  useProductListIsRestoringFromUrl,
  useProductListLoading,
  useProductListPage
} from '@/features/products/state/list/context';

interface ProductListBoxProps {
  itemsToRender: ProductListRowItem[];
  taxonData?: ListingProductCardTaxonData;
}

const ProductListItems = ({ itemsToRender, taxonData }: ProductListBoxProps) => {
  const isProductListLoading = useProductListLoading();
  const page = useProductListPage();
  const isRestoringFromUrl = useProductListIsRestoringFromUrl();

  if (isProductListLoading && ((page && page !== 1) || isRestoringFromUrl)) {
    return (
      <div className="grid items-stretch w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {[...Array(18)].map((_, index) => (
          <div key={index} className="animate-pulse h-140">
            <div className="bg-gray-200 rounded-lg h-64 w-full"></div>
            <div className="mt-4 space-y-3">
              <div className="h-6 bg-gray-200 rounded w-3/4"></div>
              <div className="h-10 bg-gray-200 rounded w-1/2"></div>
              <div className="h-6 bg-gray-200 rounded-4xl w-1/2"></div>
              <div className="h-6 bg-gray-200 rounded-4xl w-1/4"></div>
              <div className="mt-10 h-10 bg-gray-200 rounded w-1/2"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid items-stretch w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
      {itemsToRender.map((item, index) => (
        <Fragment key={index}>
          {<ProductListItem index={index} item={item} taxonData={taxonData} />}
        </Fragment>
      ))}
    </div>
  );
};

export default ProductListItems;
